export const getContrastColor = (hexcolor: string) => {
  if (hexcolor === null || hexcolor === undefined) return 'black'
  const convertedColor = hexcolor.replace('#', '')
  const r = parseInt(convertedColor.substring(1, 2), 16)
  const g = parseInt(convertedColor.substring(3, 2), 16)
  const b = parseInt(convertedColor.substring(5, 2), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? 'black' : 'white'
}

export const parseVersion = (version: string) => {
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [versionNumber, commitHash, ...branchParts] = version.split('-')
  const branch = branchParts.length > 0 ? branchParts.join('-') : ''
  return { versionNumber, branch }
}

export const isDifferentVersion = (versionA: string, versionB: string) => {
  if (!versionA || !versionB) return true

  const { versionNumber: versionNumberA, branch: branchA } =
    parseVersion(versionA)
  const { versionNumber: versionNumberB, branch: branchB } =
    parseVersion(versionB)

  if (!branchA || !branchB) return true

  const [xA, yA] = versionNumberA.split('.')
  const [xB, yB] = versionNumberB.split('.')

  return xA !== xB || yA !== yB || branchA !== branchB
}
